module.exports = __webpack_public_path__ + "052a9f6f.svg";